import { SUBSCRIPTION_PERIOD, PlansIds } from '../constants/config';

export const isFreePlan = (planId) => planId === PlansIds.FREE;
export const isProPlan = (planId) => planId === PlansIds.PRO;
export const isStandartPlusPlan = (planId) => planId === PlansIds.STANDARD_PLUS;
export const isKalturaPlan = (planId) => planId === PlansIds.KALTURA;

export const isMonthlyInterval = (interval) => interval === SUBSCRIPTION_PERIOD.MONTHLY;
export const isYearlyInterval = (interval) => interval === SUBSCRIPTION_PERIOD.YEARLY;
export const isLifetimeInterval = (interval) => interval === SUBSCRIPTION_PERIOD.LIFETIME;

// appsumo plan ids: 6, 7, 8
export const isAppsumoPlan = (planId) =>
  [PlansIds.APPSUMO_TIER1, PlansIds.APPSUMO_TIER2, PlansIds.APPSUMO_TIER3].includes(planId);

export const isFreeOrTrialUser = (user) =>
  user &&
  user.subscription &&
  (isFreePlan(user.subscription.plan) || Boolean(user.subscription.trial));

// pro or standart plus not trial user is paid user
export const isPaidUser = (user) =>
  user &&
  user.subscription &&
  !Boolean(user.subscription.trial) &&
  (isProPlan(user.subscription.plan) || isStandartPlusPlan(user.subscription.plan));

export const isMonthlyPaidUser = (user) =>
  isPaidUser(user) && isMonthlyInterval(user.subscription.interval);

export const isVisitor = (user) => !Boolean(user);
